'use client';

import ProductCard from '@/components/products/ProductCard';
import { Grid, GridItem, useBreakpointValue } from '@skin-seoul/design-system';
import { getPriceProductBasicInfo, getProductType } from '@skin-seoul/service';
import RecentlyViewedListSkeleton from './RecentlyViewedListSkeleton';
import { useSafeRouter } from '@/hooks/useSafeRouter';
import { usePageLogger, LoggingImpression } from '@/utils/logger';
import type { Product } from '@skin-seoul/service';
type RecentlyViewedListProps = {
  recentlyViewedProducts: Product[];
};
export const RecentlyViewedList = ({
  recentlyViewedProducts
}: RecentlyViewedListProps) => {
  const {
    push
  } = useSafeRouter();
  const logger = usePageLogger();
  const productLimit = useBreakpointValue({
    base: 4,
    desktop: 5
  });
  return <Grid templateColumns={{
    base: 'repeat(2, minmax(0, 1fr))',
    desktop: 'repeat(5, minmax(0, 1fr))'
  }} tablet={{
    '& > *:nth-of-type(n+5)': {
      display: 'none'
    }
  }} desktop={{
    '& > *:nth-of-type(n+5)': {
      display: 'initial'
    }
  }} gap={3} width="100%" data-sentry-element="Grid" data-sentry-component="RecentlyViewedList" data-sentry-source-file="RecentlyViewedList.tsx">
      {recentlyViewedProducts.slice(0, productLimit).map((product, index) => {
      const lowestPriceProductInfo = getPriceProductBasicInfo(product);
      const productType = getProductType(product);
      const handleProductClick = () => {
        logger?.click('recently_viewed_product_clicked_at_home', {
          position: index + 1,
          productId: product.productId
        });
        push(product.productLink);
      };
      return <LoggingImpression logName="recently_viewed_product_impression_at_home" areaThreshold={0.5} params={{
        position: index + 1,
        productId: product.productId
      }} key={product.productId}>
            <GridItem minWidth={0}>
              <ProductCard onClick={handleProductClick} href={product.productLink} name={product.name} brand={product.brand} productType={productType} productImage={product.productImageUrls[0]} sku={product.sku} currency={product.currency} originalPrice={lowestPriceProductInfo.originalPrice} salePrice={lowestPriceProductInfo.salePrice} productId={product.productId.toString()} category={product.category} />
            </GridItem>
          </LoggingImpression>;
    })}
    </Grid>;
};
const RecentlyViewedListWithSkeleton = RecentlyViewedList as typeof RecentlyViewedList & {
  Skeleton: typeof RecentlyViewedListSkeleton;
};
RecentlyViewedListWithSkeleton.Skeleton = RecentlyViewedListSkeleton;
export default RecentlyViewedListWithSkeleton;